import {lazy} from 'react';
import GenericFallbackSuspense from '../../../v2/components/ui/GenericFallback/GenericFallbackSuspense';

const DownloadButtons = lazy(() => (
  
  import('./DownloadButtons'/* webpackChunkName: 'DownloadButtons' */)
));

export default function DownloadButtonsLazyLoader() {
  return (
    <GenericFallbackSuspense>
      <DownloadButtons />
    </GenericFallbackSuspense>
  );
}
